import { render, staticRenderFns } from "./importImgs.vue?vue&type=template&id=71b45fae&scoped=true&"
import script from "./importImgs.vue?vue&type=script&lang=js&"
export * from "./importImgs.vue?vue&type=script&lang=js&"
import style0 from "./importImgs.vue?vue&type=style&index=0&id=71b45fae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b45fae",
  null
  
)

export default component.exports